import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ComparisonSection from './components/ComparisonSection';
import ArticlesSection from './components/ArticlesSection';
import TrustSection from './components/TrustSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://acbuy.monster';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'ACBuy Spreadsheet',
  url: siteUrl,
  description: 'The most updated ACBuy Spreadsheet database for global buyers to compare products, prices, and shipping efficiency — updated daily.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?search={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'ACBuy Spreadsheet',
  url: siteUrl,
  description: 'The most structured, data-driven ACBuy Spreadsheet comparison platform designed for global shoppers to find verified, low-cost products efficiently.',
};

export default function Home() {
  return (
    <>
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ComparisonSection />
        <ArticlesSection />
        <TrustSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}